import { Flex, Heading, Text } from 'roo-ui/components';

const QFFAccessErrorPage = () => (
  <Flex flex="1 1 auto" textAlign="center" alignItems="center" justifyContent="center" flexDirection="column" pt={[15, 12]} pb={[15, 25]}>
    <Heading.h1 fontSize="2xl" lineHeight="tight" mb={5} data-testid="title">
      We are unable to find the booking you are looking for
    </Heading.h1>
    <Text>
      Check your email for the correct log in link. <br />
      Make sure you are logged into the correct Qantas Frequent Flyer account.
    </Text>
  </Flex>
);

export default QFFAccessErrorPage;
